import React from 'react';

const MAIN = '#6d4e36';

/* Largeurs aléatoires fixes pour donner un aspect réaliste */
const COL_WIDTHS = [
  [55, 70, 48, 80, 65, 40, 72, 58, 44, 68, 52, 76],
  [62, 55, 75, 50, 88, 60, 45, 70, 55, 82, 48, 65],
  [48, 80, 55, 70, 42, 75, 60, 50, 78, 45, 68, 55],
  [72, 50, 65, 80, 55, 48, 70, 62, 40, 75, 58, 45],
  [58, 68, 42, 75, 60, 85, 50, 65, 72, 44, 80, 55],
  [45, 75, 60, 52, 70, 40, 80, 55, 65, 78, 48, 68],
  [70, 48, 80, 58, 45, 72, 55, 85, 42, 65, 76, 50],
  [55, 65, 70, 44, 78, 55, 62, 48, 82, 58, 45, 72],
];

const keyframes = `
  @keyframes sp-shimmer {
    0%   { background-position: -800px 0; }
    100% { background-position: 800px 0; }
  }
`;

const shimmerStyle = {
  background: 'linear-gradient(90deg, #f5ede8 25%, #e8d4c4 50%, #f5ede8 75%)',
  backgroundSize: '1600px 100%',
  animation: 'sp-shimmer 1.6s infinite linear',
  borderRadius: 4,
  display: 'inline-block',
};

const thStyle = {
  background: `linear-gradient(135deg, ${MAIN} 0%, #8b5e3c 100%)`,
  padding: '11px 12px',
  borderBottom: 'none',
};

const tdStyle = {
  padding: '11px 12px',
  verticalAlign: 'middle',
  borderBottom: '1px solid #f5ede8',
};

export default function TableSkeleton({ rows = 8, cols = 6, hasActions = true }) {
  const totalCols = hasActions ? cols + 1 : cols;

  return (
    <>
      <style>{keyframes}</style>
      <table style={{ width: '100%', borderCollapse: 'collapse' }}>
        <thead>
          <tr>
            {Array.from({ length: totalCols }).map((_, i) => (
              <th key={i} style={thStyle}>
                <div style={{
                  ...shimmerStyle,
                  height: 10,
                  width: i === totalCols - 1 && hasActions ? 48 : `${40 + (i * 17) % 35}%`,
                  background: 'linear-gradient(90deg, rgba(255,255,255,0.15) 25%, rgba(255,255,255,0.30) 50%, rgba(255,255,255,0.15) 75%)',
                  backgroundSize: '1600px 100%',
                  animation: 'sp-shimmer 1.6s infinite linear',
                  borderRadius: 4,
                }} />
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {Array.from({ length: rows }).map((_, ri) => (
            <tr key={ri} style={{ background: ri % 2 === 0 ? '#fff' : '#fdf9f7' }}>
              {Array.from({ length: totalCols }).map((_, ci) => {
                const w = COL_WIDTHS[ri % COL_WIDTHS.length][ci % 12];
                const isAction = hasActions && ci === totalCols - 1;
                return (
                  <td key={ci} style={tdStyle}>
                    {isAction ? (
                      <div style={{ display: 'flex', gap: 6 }}>
                        <div style={{ ...shimmerStyle, height: 26, width: 28, borderRadius: 6 }} />
                        <div style={{ ...shimmerStyle, height: 26, width: 28, borderRadius: 6 }} />
                      </div>
                    ) : (
                      <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
                        <div style={{ ...shimmerStyle, height: 11, width: `${w}%` }} />
                        {/* Deuxième ligne fine sur 30% des cellules */}
                        {ci % 3 === 1 && (
                          <div style={{ ...shimmerStyle, height: 8, width: `${Math.max(25, w - 20)}%`, opacity: 0.5 }} />
                        )}
                      </div>
                    )}
                  </td>
                );
              })}
            </tr>
          ))}
        </tbody>
      </table>
    </>
  );
}
